export {
  getPreviousIndex,
  getNextIndex,
  getPreviousDisabledValue,
  getNextDisabledValue,
};

function getPreviousIndex(
  loop: boolean,
  dots: number,
  currentIndex: number
): number | null {
  const previousIndex = currentIndex - 1;
  if (loop) return (previousIndex + dots) % dots;
  if (previousIndex < 0) return null;
  return previousIndex;
}

function getNextIndex(
  loop: boolean,
  dots: number,
  currentIndex: number
): number | null {
  const nextIndex = currentIndex + 1;
  if (loop) return nextIndex % dots;
  if (nextIndex === dots) return null;
  return nextIndex;
}

function getPreviousDisabledValue(
  loop: boolean,
  dots: number,
  index: number
): boolean {
  if (dots === 1) return true;
  if (loop) return false;
  return index === 0;
}

function getNextDisabledValue(
  loop: boolean,
  dots: number,
  index: number
): boolean {
  if (dots === 1) return true;
  if (loop) return false;
  return index + 1 === dots;
}
